import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const UnitRevenue = (plans, filters, counter) => ({
  plans,
  filters,
  counter,
})

export default {
  state: {
    manicure: UnitRevenue([], [], 0),
    pedicure: UnitRevenue([], [], 0),
    common: UnitRevenue([], [], 0),
    default: UnitRevenue([], [], 0),
  },
  getters: getters,
  mutations: mutations,
  actions: actions,
}
